import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-83b7989c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "TeachingClassViewContainer"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ft18"
}, "教学管理", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ButtonDialog = _resolveComponent("ButtonDialog");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_tag = _resolveComponent("el-tag");
  const _component_BatterTableDataView = _resolveComponent("BatterTableDataView");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createVNode(_component_el_row, {
    class: "wd100 wbg pd12"
  }, {
    default: _withCtx(() => [_createVNode(_component_ButtonDialog, {
      "btn-name": "新建课程",
      "btn-id": 9,
      onFresh: _cache[0] || (_cache[0] = $event => _ctx.$refs.roomTable.fetchData())
    })]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "wd100 wbg mt12 pd12"
  }, {
    default: _withCtx(() => [_createVNode(_component_BatterTableDataView, {
      ref: "roomTable",
      "table-id": 4,
      onOnDetailData: $options.onDetailData
    }, {
      state: _withCtx(data => [data.rowData == 'ON' ? (_openBlock(), _createBlock(_component_el_tag, {
        key: 0,
        type: "success"
      }, {
        default: _withCtx(() => [_createTextVNode("上课中")]),
        _: 1
      })) : (_openBlock(), _createBlock(_component_el_tag, {
        key: 1,
        type: "info"
      }, {
        default: _withCtx(() => [_createTextVNode("下课")]),
        _: 1
      }))]),
      _: 1
    }, 8, ["onOnDetailData"])]),
    _: 1
  })]);
}